<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-info-dialog-panel tenga la fascia panna a filo del bordo inferiore. -->
<h2 mat-dialog-title>Invia la fattura via email</h2>

<mat-dialog-content>
  <p class="izy-email-message">
    Verrà inviata una copia PDF del documento a questo indirizzo:
  </p>

  <!-- L'indirizzo sta in un riquadro a se', gemello di .izy-confirm-box nel
       dialog di conferma: e' il dato su cui si decide se premere Invia, non
       una riga di testo in mezzo al messaggio. -->
  @if (email_address) {
    <div class="izy-email-box izy-sharp-bl">
      <mat-icon>mail</mat-icon>
      <span class="izy-email-address">{{ email_address }}</span>
    </div>
  } @else {
    <!-- Senza indirizzo non c'e' niente da inviare: lo stesso riquadro dice
         cosa manca, e il pulsante porta dove si rimedia (la scheda del
         cliente). -->
    <div class="izy-email-box izy-email-box--empty izy-sharp-bl">
      <mat-icon>mail_off</mat-icon>
      <span>Nessun indirizzo email per questo cliente.</span>
    </div>

    <button
      mat-stroked-button
      type="button"
      (click)="openCustomerPage()"
      class="izy-button-ghost izy-button-ghost--info custom-button-border izy-goto-contact">
      <mat-icon>recent_actors</mat-icon>
      Vai alla scheda del cliente
    </button>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    mat-dialog-close
    class="izy-button-ghost custom-button-border">
    <mat-icon>arrow_back</mat-icon>
    Indietro
  </button>

  <!-- L'azione della schermata: petrol pieno bordato nero, spenta finche' non
       c'e' un indirizzo a cui inviare. -->
  <button
    matButton="filled"
    type="button"
    (click)="confirm()"
    [disabled]="!email_address"
    class="ms-2 izy-button-primary custom-button-border">
    <mat-icon>send</mat-icon>
    Invia
  </button>
</mat-dialog-actions>
